import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @customElement chancen-component-fullscreen-card
 */
@customElement('chancen-component-fullscreen-card')
export class ChancenComponentFullscreenCard extends ChemistryLitElement {
  @property() public space: string = '';
  @property() public padding: string = '';
  @property() public label: string = '';

  @state() private _fullscreen = false;

  private _getTitle() {
    return html`<chancen-component-card-title narrow>
        <cr-flex space="sm">
          ${this.label}
          <slot name="underTitle"></slot>
        </cr-flex>

        <cr-flex slot="right" horizontal space="md" crossaxis-center>
          <slot name="title-right"></slot>
          <cr-button mode="icon" icon="fullscreen" @click=${() => (this._fullscreen = !this._fullscreen)}>
            <cr-tooltip><cr-text>Vollbild</cr-text></cr-tooltip>
          </cr-button>
        </cr-flex>
      </cr-flex>
    </chancen-component-card-title>`;
  }

  override render() {
    if (this._fullscreen) {
      return html`<cr-flex
        ${css({
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 99999999,
          height: '100%',
          maxHeight: '100%',
          width: '100%',
          backgroundColor: 'white',
          overflow: 'auto',
        })}
        padding="xl"
        space="md"
      >
        ${this._getTitle()}
        <slot></slot>
      </cr-flex>`;
    }

    return html`<cr-card space="${this.space}" padding="${this.padding}">
      ${this._getTitle()}
      <slot></slot>
    </cr-card>`;
  }
}
